/**
 * Flattens a nested object structure into a single-level object with dot-notation keys
 * @param obj - The object to flatten
 * @param prefix - The prefix to use for nested keys
 * @param result - The accumulated result object
 * @returns A flattened object with dot-notation keys
 */
export const flattenObject = (
  obj: { [x: string]: any; },
  prefix = '',
  result: { [key: string]: any } = {}
): { [key: string]: any } => {
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        flattenObject(obj[key], newKey, result);
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
};
